import React, { Component } from "react";
import { connect } from "react-redux";
import { getCompanyById } from "../../../../actions/company.actions";
import Profile from "../components/Profile";

class ProfileContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getCompanyById(this.props.match.params.companyId);
  }

  render() {
    return <Profile companyData={this.props.company} />;
  }
}

const mapStateToProps = state => {
  return {
    company: state.company.company
  };
};

const mapDispatchToProps = dispatch => ({
  getCompanyById: companyId => dispatch(getCompanyById(companyId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/profile/containers/ProfileContainer.js